/**
 * Global safeguard for document.elementFromPoint
 * Validates coordinates to avoid "provided double value is non-finite" errors.
 */
export {}

declare global {
  interface Window {
    __SAFE_EFP_APPLIED__?: boolean
  }
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  if (!window.__SAFE_EFP_APPLIED__ && typeof document.elementFromPoint === 'function') {
    const original = document.elementFromPoint.bind(document) as (x: number, y: number) => Element | null;

    document.elementFromPoint = ((x: number, y: number): Element | null => {
      const nx = Number(x);
      const ny = Number(y);
      if (!Number.isFinite(nx) || !Number.isFinite(ny)) {
        if (import.meta.env.MODE !== 'production') {
          console.warn('[safeElementFromPoint] Ignored non-finite coordinates', { x, y });
        }
        return null;
      }
      try {
        return original(nx, ny);
      } catch (err) {
        if (import.meta.env.MODE !== 'production') {
          console.warn('[safeElementFromPoint] elementFromPoint threw:', err, { x: nx, y: ny });
        }
        return null;
      }
    }) as Document['elementFromPoint'];

    // Also safeguard elementsFromPoint which some libraries use internally
    if (typeof (document as any).elementsFromPoint === 'function') {
      const originalMany = (document as any).elementsFromPoint.bind(document) as (x: number, y: number) => Element[];
      (document as any).elementsFromPoint = ((x: number, y: number): Element[] => {
        const nx = Number(x);
        const ny = Number(y);
        if (!Number.isFinite(nx) || !Number.isFinite(ny)) {
          if (import.meta.env.MODE !== 'production') {
            console.warn('[safeElementFromPoint] Ignored non-finite coordinates (multiple)', { x, y });
          }
          return [];
        }
        try {
          return originalMany(nx, ny);
        } catch (err) {
          if (import.meta.env.MODE !== 'production') {
            console.warn('[safeElementFromPoint] elementsFromPoint threw:', err, { x: nx, y: ny });
          }
          return [];
        }
      }) as Document['elementsFromPoint'];
    }

    window.__SAFE_EFP_APPLIED__ = true;
  }
}
